import * as React from "react";
import PropTypes from "prop-types";
const SvgActivitySegmentNormalSmall = React.forwardRef(
  ({ color = "currentColor", size = 24, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M10.134 21.87c.336.408.617.733.816.958.341.387.698.76 1.05 1.138l1.05-1.138a41.579 41.579 0 003.282-4.273C18.094 15.912 20 12.32 20 9c0-2.688-1.04-4.719-2.606-6.063C15.855 1.612 13.864 1 12 1s-3.854.612-5.395 1.937C5.041 4.28 4 6.312 4 9c0 3.32 1.906 6.912 3.668 9.555a41.563 41.563 0 002.466 3.315zM7.91 4.453C9.04 3.481 10.55 3 12 3s2.96.481 4.09 1.453C17.199 5.405 18 6.874 18 9c0 2.68-1.594 5.838-3.332 8.445A39.555 39.555 0 0112 20.985a39.566 39.566 0 01-2.668-3.539C7.594 14.837 6 11.68 6 9c0-2.126.802-3.595 1.91-4.547z"
        fill=""
      />
    </svg>
  )
);
SvgActivitySegmentNormalSmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgActivitySegmentNormalSmall;
